module.exports = __webpack_public_path__ + "media/images/etyekilogo-etyeki-120x120-9141c1b0a28687906f02e861544cd7b8.png";